module.exports = __webpack_public_path__ + "static/omega_g2-f846078e4a2dc6b1bb70b2599598ac9c.jpg";